import React, { FunctionComponent } from 'react'

import GlobalInfo from 'components/GlobalInfo'

const NotFound: FunctionComponent = () => {
  return <GlobalInfo statusCode={404} />
}

export default NotFound
